import React from 'react';

import styled from '@emotion/styled';

import { Modal } from '../../components/Modal/Modal';
import { TableComponent } from '../../components/TableCom';
import { ModalProvider } from '../../context/ModalContext';
import { TableRefreshProvider } from '../../context/TableRefreshContext';
import CreateAdminUser from '../../sections/dashboard/users/CreateAdminUser';
import CreateAdminUserModal from '../../sections/dashboard/users/CreateAdminUserModal';

const AdminUser = () => {
  return (
    <TableRefreshProvider>
      <ModalProvider>
        <Container>
          <CreateAdminUser />
          <TableComponent
            tableBaseUrl="authentication-service/v1/warehouse/users"
            tableHeader={[
              'firstName',
              'lastName',
              'phoneNumber',
              'email',
              'verified',
            ]}
            mappingData={{
              firstName: 'First Name',
              lastName: 'Last Name',
              phoneNumber: 'Phone Number',
              email: 'Email',
              verified: 'Verified',
            }}
          />
        </Container>
        <Modal>
          <CreateAdminUserModal />
        </Modal>
      </ModalProvider>
    </TableRefreshProvider>
  );
};

export default AdminUser;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;
